module.exports = __webpack_public_path__ + "63a155d3f2bd2f6f03c84d27609ad29c.png";